module.exports = __webpack_public_path__ + "static/media/eiffelExplore.aff68047.png";